import { axiosInstance as axios } from "services";

export const updateCustomPlan = async (companyId, body) => {
  const { data } = await axios.put(`/admin/subscription/company/${companyId}/custom-plan`, body);
  if (!data.success) throw new Error(data.error?.message || "Failed to update custom plan");
  return data;
};

